import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "eduid-hooks";
import { useEffect, useRef, useState } from "react";
import { Field as FinalField } from "react-final-form";
import { FormattedMessage, useIntl } from "react-intl";
import { InputWrapper } from "./InputWrapper";
import { ShowAndHideButton } from "./ShowAndHideButton";
export function PasswordInput({ name, autoComplete, helpBlock }) {
    const intl = useIntl();
    // placeholder can't be an Element, we need to get the actual translated string here
    const placeholder = intl.formatMessage({
        id: "passwordInput.placeholder",
        defaultMessage: "enter password",
        description: "placeholder text for password input",
    });
    return (_jsx(FinalField, { type: "password", name: name, component: WrappedPasswordInput, autoComplete: autoComplete, required: true, placeholder: placeholder, 
        // parameters for InputWrapper
        helpBlock: helpBlock, label: _jsx(FormattedMessage, { id: "common.password", defaultMessage: "Password", description: "password input field label" }) }));
}
export function WrappedPasswordInput(props) {
    // the InputWrapper renders it's children plus a label, helpBlock and any error message from the field validation
    return (_jsx(InputWrapper, Object.assign({}, props, { children: _jsx(PasswordInputElement, Object.assign({}, props)) })));
}
/**
 * Render a Password input component and a Show/Hide button to toggle between text-input and password-input.
 * @param props
 * @returns
 */
export function PasswordInputElement({ meta, disabled, input, placeholder, autoComplete, autoFocus, }) {
    const [showPassword, setShowPassword] = useState(false);
    const inputRef = useRef(null);
    const forced_username = useAppSelector((state) => state.login.authn_options.forced_username);
    useEffect(() => {
        var _a;
        if (inputRef.current && forced_username)
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [forced_username]);
    let className = "is-valid";
    if (meta.touched || meta.submitFailed) {
        if (meta.invalid) {
            className = "is-invalid";
        }
    }
    if (disabled) {
        className = "disabled";
    }
    return (_jsxs("div", { className: "password-input", children: [_jsx(ShowAndHideButton, { isShown: showPassword, onClick: () => setShowPassword(!showPassword) }), _jsx("input", Object.assign({}, input, { id: input.name, type: showPassword ? "text" : "password", placeholder: placeholder, autoComplete: autoComplete, autoFocus: autoFocus, className: className, ref: inputRef }))] }));
}
